/*
  Klevu theme configuration.
  Externalized 2026-07-17 (site-speed audit 86bajme4c) from the inline <script>
  in snippets/klevu-quick-search-theme.liquid so it can load with `defer` —
  it must execute after the Klevu core (js.klevu.com/core/v2/klevu.js), which
  document-order defer guarantees. JS content is unchanged from the inline block.
*/

klevu.interactive(function() {
          klevu({
              powerUp: {
                  landing: false,
                  catnav: false,
                  quick: false,
              }
          });
      });
  klevu.interactive(function () {
      var options = {
        theme: {
          modules: {
            resultInfiniteScroll: {

              searchResultsPage: {
                enable: true
              },

            }
          }
        },
          url : {
              landing: '/search', // your Shopify Search Results Page
              search: klevu.settings.url.protocol + '//eucs30v2.ksearchnet.com/cs/v2/search' // your Klevu APIv2 Search URL
          },
          search: {
              minChars: 0,
              searchBoxSelector: 'input[name=q],.kuSearchInput', // your Shopify Search Input
              apiKey: "klevu-166146116341215573" // your Klevu JS API Key
          },
          analytics: {
              apiKey: 'klevu-166146116341215573' // your Klevu JS API Key
          }
      };
      klevu(options);
  });
